import React from 'react';
import './Car.css';

import { Button } from '../../components';
import { calculateAverageRating } from '../../utils';

import { FaStar, FaCar, FaUser, FaGasPump, FaCarSide, FaSuitcase } from 'react-icons/fa';
import { FaGears } from 'react-icons/fa6';

import { Link } from 'react-router-dom';



const Car = ({ car, list }) => {

  // Calculate the average rating of the car based on user reviews
  const averageRating = calculateAverageRating(car); 

  // Generate the full car name using make and model details
  const carName = `${car.details.carMake} ${car.details.carModel}`;

  return ( 
    <div className="car-item">

      {/* Car Image Container */}
      <div className='image'> 
        <img src={car.image} alt={carName} /> {/* Car Image */}
        <div className='price'>${car.price}<span>/day</span></div> {/* Car Price */}
      </div>

      <div className="content">

        {/* Car rating */}
        <div className='rating'>
          <div className='icon'>
            {/* Display star icons for rating */}
            <FaStar /> <FaStar /> <FaStar /> <FaStar /> <FaStar />
          </div>
          {/* Display average rating and number of comments */}
          {car.comments.length > 0 ? (
            <h5>{averageRating} ({car.comments.length})</h5>
          ) : (
            <h5>Not rated</h5>
          )}
        </div>

        {/* Car name with link to car details page */}
        <Link to={{
            pathname: '/Cars/' + carName,
          }}
          state={car}>
          <h2>{carName}</h2>
        </Link>

        {/* Car specifications */}
        <div className="details">
          <h3><FaCar className="icon" /><span>{car.details.year}</span></h3> {/* Car manufacturing year */}
          <h3><FaCarSide className="icon" /><span>{car.details.carType}</span></h3> {/* Car Type */}
          <h3><FaUser className="icon" /><span>{car.details.seats}</span></h3> {/* Seating capacity */}
          <h3><FaSuitcase className="icon" /><span>{car.details.suitcase}</span></h3> {/* Suitcase/luggage capacity */}
          <h3><FaGears className="icon" /><span>{car.details.transmission}</span></h3> {/* Transmission type */}
          <h3><FaGasPump className="icon" /><span>{car.details.fuelType}</span></h3> {/* Fuel type */}
        </div>

        {/* Display car description only in list view */}
        {list && <p>{car.content}</p>} {/* Product description */}
        
        <Button link={'Car-Booking'} title={'Rent Car'} /> {/* Rent Car button */}

      </div>
    </div>
  );
};

export default Car;